export default __webpack_public_path__ + "static/media/seattle2.02d142e9.jpg";